import has from 'lodash/has'

export default ReferencesService

/** @ngInject */
function ReferencesService($rootScope, DataAccessReferences) {
    const refsPromise = {}

    const getRefPromise = function (ref) {
        if (!has(refsPromise, ref)) {
            refsPromise[ref] = DataAccessReferences.ref({ id: ref }).$promise
        }
        return refsPromise[ref]
    }

    return {
        getRefPromise,
    }
}



// WEBPACK FOOTER //
// ./src/services/references/references.js